import React, { Component } from "react";
import { Typography, Button } from "@material-ui/core";
import { Field } from 'redux-form';
import { Input } from 'scorpion-core';
import logo from '../../logo'

import View from 'react-flexbox'
class SignUp extends Component {
  constructor(props) {
    super(props);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }
  handleFormSubmit(props) {
    this.props.createUser(props.nome, props.email, props.senha, () => this.props.history.push("/private/inicio"))
  }

  render() {
    const { handleSubmit, errorMensage } = this.props;
    return (<View style={{  justifyContent: "center" }}>
      <div style={{ maxWidth: 500 }}>
        <div style={{ display: 'flex', justifyContent: "center" }}>
          <img src={logo} />
        </div>
        <div style={{ display: 'flex', justifyContent: "center" }}>
          <Typography variant="h6" color="inherit" >
            Criar nova conta
          </Typography>
        </div>
        {errorMensage && <Typography style={{ color: "#f00" }}> {errorMensage}</Typography>}
        <Field name="nome" placeholder="Nome" component={Input} />
        <Field name="email" placeholder="Email" component={Input} />
        <Field name="senha" placeholder="Senha" type="password" component={Input} />
        <div style={{ display: 'flex', justifyContent: "center" }}>
          <Button variant="contained" color="primary" style={{ margin: 8 }} onClick={handleSubmit(this.handleFormSubmit)}>Criar</Button>

        </div>
        <div style={{ display: 'flex', justifyContent: "center" }}>


          <a onClick={() => {
            this.props.reset();
            this.props.history.push("/Login")
          }}>Já tenho uma conta</a>

        </div>

      </div>
    </View>
    );
  }
}


export default SignUp;


// WEBPACK FOOTER //
// ./src/routes/public/Login/components/SignUp/SignUp.js